import React from 'react';
import { FadeIn } from './ui/FadeIn';
const items = [{
  title: 'Los 6 servicios explicados paso a paso',
  desc: 'Exactamente qué hacer, cuánto cobrar y a quién buscar.'
}, {
  title: '7 mensajes listos para copiar y enviar',
  desc: 'Para WhatsApp, Instagram y grupos de Facebook — sin sonar a spam.'
}, {
  title: 'El Operativo 48 Horas',
  desc: 'Un plan exacto hora por hora para los 2 primeros días.'
}, {
  title: 'Dónde encontrar clientes en 24 horas',
  desc: 'WhatsApp, Instagram, grupos de Facebook, Mercado Libre, LinkedIn.'
}, {
  title: 'Cómo cobrar sin fricción',
  desc: 'Métodos de pago para Colombia, México, Argentina, Venezuela, Chile, Perú y España.'
}, {
  title: 'Qué hacer si no funciona',
  desc: 'Plan B exacto con 3 pasos concretos.'
}];
export const WhatYouGet = () => {
  return <section className="py-20 md:py-24 bg-dark-card border-y border-white/5" data-id="element-292">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-293">
        <FadeIn data-id="element-294">
          <div className="text-center mb-12" data-id="element-295">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-296">
              Contenido del PDF
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-297">
              Qué incluye exactamente
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-298">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-299">
              <div className="bg-[#111111] border border-white/10 rounded-xl p-6 md:p-7 flex items-start gap-5 hover:border-[#ADFF2F]/40 transition-colors" data-id="element-300">
                <div className="shrink-0 text-2xl mt-0.5" data-id="element-301">📌</div>
                <div className="flex-1" data-id="element-302">
                  <h3 className="text-lg md:text-xl text-white font-bold mb-1 font-sans" data-id="element-303">
                    {item.title}
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed font-sans m-0" data-id="element-304">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};